<div class="boels-sorting__dropdown">
  <label>{{ 'productList.sortBy' | transloco }}</label>
  <div class="sorting-wrapper">
    <fa-icon [icon]="faSort" class="sorting-icon"></fa-icon>
    <ng-select
      [searchable]="false"
      [clearable]="false"
      (change)="sort($event)"
      [ngModel]="selectedOption"
    >
      @for (sort of sortOptions; track sort) {
        <ng-option [value]="sort.code">
          <span>
            {{ sort.name }}
          </span>
        </ng-option>
      }
    </ng-select>
  </div>
</div>
